const $ = require('jquery');
const _ = require('lodash');

module.exports = function (trolleyService, inlineMessageService, $timeout, moveFocus, settingsService, trolleySource, decorateAdditionalDetails, shopperService) {

    return {
        restrict: 'E',
        scope: {
            trolleyItem: '='
        },
        link($scope) {
            $scope.collectionZoneItemIsInit = false;

            $scope.shopperService = shopperService;

            function checkRestrictedCategory() {
                // check if product is in a restricted category
                if ($scope.trolleyItem && $scope.trolleyItem.ProductData && $scope.trolleyItem.ProductData.categoryleafnodeid) {
                    settingsService.getSettingValue('ProductRestrictions', 'CategoryIds').then((restrictedCategories) => {
                        $scope.trolleyItem.isInRestrictedCategory = (_.intersection(restrictedCategories, $scope.trolleyItem.ProductData.categoryleafnodeid.map(id => id.toString())).length > 0);
                    });
                }
            }

            function updateSuccess() {

                checkRestrictedCategory();

                $timeout(function () {
                    let shouldGetInlineMsg = true;
                    $scope.isUpdating = false;

                    if ($scope.trolleyItem.MissedPromotions.length) {
                        inlineMessageService.initMissedPromotions($scope.trolleyItem);
                        shouldGetInlineMsg = true;
                    } else {
                        inlineMessageService.removeInlineMessage($scope.trolleyItem.Stockcode, 'MissedPromotion');
                    }

                    if ($scope.trolleyItem.MatchedPromotions.length) {
                        inlineMessageService.initMatchedPromotions($scope.trolleyItem);
                        shouldGetInlineMsg = true;
                    } else {
                        inlineMessageService.removeInlineMessage($scope.trolleyItem.Stockcode, 'MatchedPromotion');
                    }

                    if ($scope.trolleyItem.HasError) {
                        inlineMessageService.initErrorMessages($scope.trolleyItem, $scope.deliveryPassLimitMessage);
                        shouldGetInlineMsg = true;
                    }
                    if (shouldGetInlineMsg) {
                        $scope.inlineMessage = inlineMessageService.getMostRecentInlineMessage($scope.trolleyItem);
                    }
                }, 0);
            }


            function init() {
                $scope.isUpdating = false;

                $scope.productCollection = { Products: decorateAdditionalDetails($scope.trolleyItem.AssociatedProducts) };

                if ($scope.trolleyItem) {
                    $scope.productParent = _.find($scope.trolleyItem.AssociatedProducts, { Stockcode: $scope.trolleyItem.ParentStockcode });
                }

                checkRestrictedCategory();

                $timeout(function () {
                    inlineMessageService.initItemMessages($scope.trolleyItem, $scope.deliveryPassLimitMessage);
                    $scope.inlineMessage = inlineMessageService.getMostRecentInlineMessage($scope.trolleyItem);
                    $scope.collectionZoneItemIsInit = true;
                }, 0);
            }

            $scope.trolleySource = trolleySource.collectionZone;

            $scope.selectedProduct = { product: $scope.trolleyItem };

            $scope.trolleyControlsOpen = false;

            $scope.toggleTrolleyControls = function (e) {
                const $cartPanel = $('.cart-inner-wrapper');

                $cartPanel.animate({
                    scrollTop: $cartPanel.scrollTop() + $(e.currentTarget).closest('.js-cart-item').offset().top - 213
                }, 450);

                $scope.trolleyControlsOpen = !$scope.trolleyControlsOpen;

            };

            $scope.success = updateSuccess;

                $scope.error = init;
                $scope.loading = function () {
                    $scope.isUpdating = true;
                };

                $scope.remove = function () {
                    $scope.isDeleting = true;
                    trolleyService
                        .removeTrolleyItem($scope.trolleyItem.Stockcode, $scope.trolleyItem, 'cart')
                        .then(function () {
                            const inlineMessage = inlineMessageService.getMostRecentInlineMessage($scope.trolleyItem);
                            if (inlineMessage) {
                                inlineMessageService.removeInlineMessage(inlineMessage.stockcode, inlineMessage.type);
                            }
                        });

            };

            // Checking if any message needs to be displayed after dismissing a message
            $scope.inlineMessageDismissed = function (event) {
                $scope.inlineMessage = inlineMessageService.getMostRecentInlineMessage($scope.trolleyItem);
                const $trolleyItem = $(event.currentTarget).closest('.trolley-item');
                moveFocus($trolleyItem);
            };

            settingsService.getSettingValue('DeliveryPass', 'ExceededMaxActiveDeliveryPassesMessage').then(function (setting) {
                $scope.deliveryPassLimitMessage = setting;
            });

            $scope.getLabel = function () {
                return $scope.trolleyItem.AvailableStock < $scope.trolleyItem.Quantity ?
                        ($scope.trolleyItem.AvailableStock === 0 ? 'Unavailable'
                        : $scope.trolleyItem.AvailableStock + ' of ' + $scope.trolleyItem.Quantity + ' available')
                            : undefined;
            };

            init();

            $scope.$watchCollection('trolleyItem', () => {
              updateSuccess();
            });
        },
        template: require('./collection-zone-item-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/collectionzone/collection-zone-item-directive.js
 **/